import { render, staticRenderFns } from "./PurchaseOrderItemDetail.vue?vue&type=template&id=4b0fbc62&scoped=true&"
import script from "./PurchaseOrderItemDetail.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderItemDetail.vue?vue&type=style&index=0&id=4b0fbc62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0fbc62",
  null
  
)

export default component.exports